export enum CurrencySymbol {
    PESOS_ARGENTINOS = '$',
}